


























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import CarbonfactorPO from "@/store/entities/basedata/carbonfactorpo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
@Component({
    components: { TreeSelect },
})
export default class CreateCarbonfactor extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    carbonfactorpo: CarbonfactorPO = new CarbonfactorPO();
    loading: boolean = false;
    created() {
        this.getItemDetail();
    }
    create() {
        //console.log(this.list);
    }
    /**获取表计类型 */
    getItemDetail() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
        if (detaillist.length > 0) {
            var metertype = detaillist.filter((item) => {
                return item.itemId === 7;
            })
            metertype.forEach((ele) => {
                this.$data.meterType.push({ label: ele.name, value: ele.id });
            });
        }
    }
    save() {
        (this.$refs.areaForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                await this.$store.dispatch({
                    type: "carbonfactor/create",
                    data: this.carbonfactorpo,
                }).catch(() => {
                    this.loading = false;
                });
                this.loading = false;
                (this.$refs.areaForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.areaForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
    }
    areaRule = {
        resourceId: [
            {
                required: true,
                message: this.L("NameCanNotBeEmpty"),
                trigger: "blur",
                type: 'number'
            },
        ],
        factor: [
            {
                type: "number",
                require: true,
                message: this.L("NameCanNotBeEmpty"),
                trigger: "blur",
            },
        ],
    };
    data() {
        return {
            meterType: [],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
}
